
export function fx_DocStamp(timeStamp: number, toUid: string, toFName: string, toLName: string, toPicURL: string, 
    fromUid: string, fromFName: string, fromLName: string, fromPicURL: string, docInfodocId: string, 
    docInfodocPath: string, docInfodocPathCollection: string, docInfoparentdocId: string, docInfoparentdocPath: string, 
    docInfoparentdocPathCollection: string) {
      
    const docStampPress = {
      userInfoTo: {
        uid: toUid,
        firstName: toFName,
        lastName: toLName,
        profilePicURL: toPicURL,
      },
      userInfoFrom: {
        uid: fromUid,
        firstName: fromFName,
        lastName: fromLName,
        profilePicURL: fromPicURL,
      },
      timestamp: {
          createdAt: timeStamp,
          updatedAt: timeStamp,
      },
      docInfo: {
        docId: docInfodocId,
        docPath: docInfodocPath,
        docPathCollection: docInfodocPathCollection,
        parent: {
          docId: docInfoparentdocId,
          docPath: docInfoparentdocPath,
          docPathCollection: docInfoparentdocPathCollection,
        }
      }
    };
    return docStampPress;
  }

  
//   import { fx_DocStamp } from "../functions/Fx_DocStamp";
    // 1 - create the docStamp for the jobDoc
//   const docStamp = fx_DocStamp(
//     Date.now(), // timestamp
//     "toUid", // to Uid
//     "toFname", // to fName
//     "toLName", // to lName
//     "toPicURL", // to Pic URL
//     "fromUid", // from Uid
//     "fromFName", // from fName
//     "fromLName", // from L Name
//     "fromPicURL", // from Pic URL
//     "docInfoDocId", // docInfo_docId
//     "docInfoDocPath", // docInfo_docPath
//     "docInfoDocPathCollection", // docInfo_docPathCollection
//     "docInfoParentDocId", // docInfo_parentDocId
//     "docInfoParentDocPath", // docInfo_parentDocPath
//     "docInfoParentDocPathCollection", // docInfo_parentDocPathCollection
//   );
//   console.log(docStamp);